import React, { Component } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SettingsIcon from "@mui/icons-material/Settings";
import BusinessIcon from "@mui/icons-material/Business";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import commStyles from "../../styles/styledComponents";
import "./styles.css";
const { IconWhiteHover } = commStyles;

class RenderTable extends Component {
  state = {
    page: 0,
    rowsPerPage: this.props.rowsPerPage || 5,
    totalPrice: 0,
  };

  handleChangePage = async (event, newPage) => {
    const response = await this.props.handleChangePage(
      newPage,
      this.state.rowsPerPage
    );
    if (response) {
      this.setState({
        page: newPage,
      });
    }
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({
      page: 0,
      rowsPerPage: +event.target.value,
    });
    this.props.handleChangePage(0, +event.target.value);
  };

  render() {
    let totalPrice = 0;
    // if (this.props.dataValues.length > 0){
    //   this.props.dataValues.map( number => {}
    // }
    return (
      <Paper sx={{ width: this.props.width || "100%", overflow: "hidden" }}>
        <TableContainer
          className="style-1"
          // viewPort-header-filterHeight-fooerPagination-marginTopBotton-paddingTopBotton
          sx={{ maxHeight: this.props.maxHeight || "100%" }}
        >
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {this.props.columns.map((column) => (
                  <TableCell
                    sx={{
                      backgroundColor: "#000040;",
                      textAlign: "center",
                      fontSize: "13px",
                      fontWeight: "bold",
                      color: "#FFF",
                      fontFamily:
                        'Montserrat, "PT Sans Caption", Arial, sans-serif',
                      textTransform: "uppercase",
                    }}
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.dataValues
                .slice(
                  this.state.page * this.state.rowsPerPage,
                  this.state.page * this.state.rowsPerPage +
                    this.state.rowsPerPage
                )
                .map((row) => {
                  totalPrice = totalPrice + parseInt(row.discountedPrice);
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                      {this.props.columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            sx={{
                              borderRight: "1px solid rgb(238, 238, 238)",
                              textAlign: "center",
                            }}
                            key={column.id}
                            align={column.align}
                          >
                            {
                              // customized table cells !!!
                              column.id == "operationEditDelete" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                  }}
                                >
                                  <IconWhiteHover
                                    onClick={() => {
                                      this.props.editModel(row);
                                    }}
                                  >
                                    <EditIcon />
                                  </IconWhiteHover>
                                  <IconWhiteHover
                                    onClick={() => {
                                      this.props.deleteEntry(row);
                                    }}
                                  >
                                    <DeleteForeverIcon />
                                  </IconWhiteHover>
                                </div>
                              ) : column.id == "status" &&
                                row.status == "sold" ? (
                                `${value} (BuyerId: ${row.buyerId})`
                              ) : column.id == "operationDelete" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                  }}
                                >
                                  <IconWhiteHover
                                    onClick={() => {
                                      this.props.deleteEntry(row);
                                    }}
                                  >
                                    <DeleteForeverIcon />
                                  </IconWhiteHover>
                                </div>
                              ) : column.id == "settingActions" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                  }}
                                >
                                  <IconWhiteHover
                                    onClick={() => {
                                      this.props.settingActionsClick(row);
                                    }}
                                  >
                                    <SettingsIcon />
                                  </IconWhiteHover>
                                </div>
                              ) : column.id == "userAddresses" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                  }}
                                >
                                  <IconWhiteHover
                                    onClick={() => {
                                      this.props.openAddress(row);
                                    }}
                                  >
                                    <BusinessIcon />
                                  </IconWhiteHover>
                                </div>
                              ) : column.id == "orderStatus" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                  }}
                                >
                                  {value == "Order Success" ? (
                                    <IconWhiteHover style={{ color: "green" }}>
                                      {value} <CheckCircleIcon />
                                    </IconWhiteHover>
                                  ) : (
                                    <IconWhiteHover style={{ color: "red" }}>
                                      {value} <ErrorOutlineIcon />
                                    </IconWhiteHover>
                                  )}
                                </div>
                              ) : column.format && typeof value === "number" ? (
                                column.format(value)
                              ) : (
                                value
                              )
                            }
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
          {this.props.dataValues.length == 0 ? (
            <div
              style={{
                width: "100%",
                height: "38px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {this.props.emptyMessage || "Your Cart is empty"}
            </div>
          ) : (
            ""
          )}
          {this.props.showPriceTotal && this.props.dataValues.length > 0 ? (
            <Table>
              <TableBody>
                <TableCell
                  sx={{
                    width: this.props.columns.length == 3 ? "100%" : "65.1vw",
                    borderRight: "1px solid rgb(238, 238, 238)",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  Total Amount
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid rgb(238, 238, 238)",
                    textAlign: "center",
                  }}
                  align={
                    this.props.columns[3]
                      ? this.props.columns[3].align
                        ? this.props.columns[3].align
                        : ""
                      : ""
                  }
                >
                  ₹ {totalPrice} /-
                </TableCell>
              </TableBody>
            </Table>
          ) : (
            ""
          )}
        </TableContainer>
        <TablePagination
          sx={{
            display:
              this.props.dataValues.length <= this.props.totalSize
                ? "none"
                : "flex",
            justifyContent: "center",
          }}
          rowsPerPageOptions={[5, 20, 50, 100]}
          component="div"
          count={this.props.totalSize}
          rowsPerPage={this.state.rowsPerPage}
          page={this.state.page}
          onPageChange={this.handleChangePage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
        />
      </Paper>
    );
  }
}

export default RenderTable;
